import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    borderRadius: 6.2,
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    ...cardShadow,
    marginBottom: 16,
  }),
  nameTextStyle: {
    fontSize: 18,
    lineHeight: 24,
    ...Fonts.type.bold,
    alignSelf: 'center',
  },
  viewProfileButtonStyle: {
    marginTop: 17,
  },
  rowContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  nameAndIconContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  removeUserContainerStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    alignSelf: 'center',
  },
  removeUserTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.hyperlinkSix,
  }),
  removeUserIconStyle: {
    marginLeft: 4,
  },
  userIconStyle: {
    marginRight: 8,
  },
  usageViewItemContainerStyle: {
    marginTop: 15,
  },
  viewProfileButtonTextStyle: {
    fontSize: 18.7,
    lineHeight: 25,
  },
  divider: theme => ({
    height: 1,
    width: '100%',
    backgroundColor: theme.colors.dividerThree,
    paddingHorizontal: 16,
    marginTop: 17,
    marginBottom: 3,
  }),
});
